export default __webpack_public_path__ + "static/clock-f6ee13121ebb538aeeb371fbf65add74.png";